import { combineReducers } from 'redux';
import overlayLayer from './overlayLayer/OverlayLayerReducer';
import profiles from './profiles/ProfilesReducer';
import mapping from './mapping/MappingReducer';
import targetFields from './targetFields/TargetFieldsReducer';
import files from './files/FilesReducer';
import mappingFile from './mapping/MappingFileReducer';
import rules from './rules/RulesReducer';
import organizations from './organizations/OrganizationsReducer';
import connections from './connections/ConnectionsReducer';
import importHistory from './importHistory/ImportHistoryReducer';
import translationTable from './translationTable/TranslationTableReducer';
import vendors from "./vendors/VendorsReducer";
import invoices from './invoices/InvoicesReducer';
import lineData from './lineDataInformation/LineDataInformationReducer';
import transactionSummary from './transactionSummary/TransactionSummaryReducer';
import profileTranslationTables from "./profileTranslationTables/ProfileTranslationTablesReducer";
import invoiceDetail from './invoiceDetail/InvoiceDetailReducer';
import costObjs from './costObjs/CostObjsReducer';
import allocationUnits from './allocationUnits/AllocationUnitsReducer';
import { connectRouter } from 'connected-react-router';
import contexts from './contexts/ContextsReducer';
import manageUser from './manageUser/ManageUserReducer';
import authentication from './auth/AuthReducer';
import reports from './report/ReportReducer';
import { S1ServiceUiReducers } from 's1-service-ui-components';
import taxCalculation from './taxCalculation/TaxCalculationReducer';
import invoiceFilters from './invoiceFilters/InvoiceFiltersReducer';
import invoiceLinesFilters from './invoiceLinesFilters/InvoiceLinesFiltersReducer';
import logs from './logs/LogReducer';

import { routerReducer } from 'react-router-redux';

export default history => combineReducers({
  router: connectRouter(history),
  connections,
  organizations,
  translationTable,
  overlayLayer,
  routing: routerReducer,
  profiles,
  mapping,
  mappingFile,
  targetFields,
  files,
  rules,
  importHistory,
  vendors,
  invoices,
  lineData,
  transactionSummary,
  profileTranslationTables,
  invoiceDetail,
  costObjs,
  allocationUnits,
  contexts,
  authentication,
  reports,
  taxCalculation,
  logs,
  manageUser,
  invoiceFilters,
  invoiceLinesFilters,
  S1UserAdmin: S1ServiceUiReducers.S1UserAdmin,
});

// export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux/rootReducer.js